import type { IMetadata } from "@adloid-technologies/discover-sdk";

/**
 * GMC Yukon (linkId 2368, project 59).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2368.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape, following the conventions established for 2382/2377:
 * consolidate-or-split fingerprinting per entity, `autoIntelRPOCode` from
 * `brandItemCode`, real condition/isDefault/isStop threading on accessory
 * messages, model-level `hotspots` built from the default variant, and
 * `groupId`/`isDefault` derived from `removeAccessories` via connected
 * components (with single-select group categories normalised to the group's
 * dominant category — 1.0 sometimes mislabels one member).
 *
 * DATA GAP: every 1.0 image reference for this project (colours,
 * features, accessories, packages, variant catalog) is stored without a
 * file extension and does not resolve on the deployed 1.0 host under any
 * extension tried — confirmed this is a genuine GCS 404 (via
 * x-goog-generation response headers), not a host/routing problem, and
 * that the 1.0 app itself has no extension-guessing logic either, so the
 * 1.0 PRODUCTION configurator is equally unable to render these renders.
 * Every `image` field below is left as an empty string rather than a
 * fabricated path. Presentation-level assets (video, slider,
 * transition logo, HDRI backgrounds) exist and are wired normally.
 *
 * Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Yukon: {
      id: "Yukon",
      lightingIdentifier: {
        interior: "dome",
        exterior: "dome",
      },
      postProcessingIdentifier: {
        interior: "dome",
        exterior: "dome",
      },
      backgroundIdentifer: "dome",
      variants: {
        "elevation-4wd": {
          defaultSkus: [
            {
              id: "common_exterior",
              sku: "5043",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "interior-color",
              sku: "5047",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "exterior-color",
              sku: "5036",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "drive_system",
              sku: "5056",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "dome",
              sku: "7090",
              projectId: "59",
              position: [0, 0, 0],
              maxResolution: {
                ios: "2K",
                android: "4K",
              },
            },
          ],
          interiorColorIdentifier: "interior-color",
          exteriorColorIdentifier: "exterior-color",
        },
        "elevation-2wd": {
          defaultSkus: [
            {
              id: "common_exterior",
              sku: "5043",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "interior-color",
              sku: "5047",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "exterior-color",
              sku: "5036",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "drive_system",
              sku: "5058",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "dome",
              sku: "7090",
              projectId: "59",
              position: [0, 0, 0],
              maxResolution: {
                ios: "2K",
                android: "4K",
              },
            },
          ],
          interiorColorIdentifier: "interior-color",
          exteriorColorIdentifier: "exterior-color",
        },
        at4: {
          defaultSkus: [
            {
              id: "common_exterior",
              sku: "5045",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "interior-color",
              sku: "5049",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "exterior-color",
              sku: "5036",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "dome",
              sku: "7090",
              projectId: "59",
              position: [0, 0, 0],
              maxResolution: {
                ios: "2K",
                android: "4K",
              },
            },
          ],
          interiorColorIdentifier: "interior-color",
          exteriorColorIdentifier: "exterior-color",
        },
        "at4-ultimate": {
          defaultSkus: [
            {
              id: "common_exterior",
              sku: "5044",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "interior-color",
              sku: "5048",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "exterior-color",
              sku: "5036",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "dome",
              sku: "7090",
              projectId: "59",
              position: [0, 0, 0],
              maxResolution: {
                ios: "2K",
                android: "4K",
              },
            },
          ],
          interiorColorIdentifier: "interior-color",
          exteriorColorIdentifier: "exterior-color",
        },
        denali: {
          defaultSkus: [
            {
              id: "common_exterior",
              sku: "5046",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "interior-color",
              sku: "5050",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "exterior-color",
              sku: "5036",
              projectId: "59",
              position: [0, 0, 0],
            },
            {
              id: "dome",
              sku: "7090",
              projectId: "59",
              position: [0, 0, 0],
              maxResolution: {
                ios: "2K",
                android: "4K",
              },
            },
          ],
          interiorColorIdentifier: "interior-color",
          exteriorColorIdentifier: "exterior-color",
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: "7090",
          project: "59",
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: "7089",
          project: "59",
        },
      },
      ambientLighting: {
        ambientColors: "",
        ambientLightings: {},
        relevantVariants: [],
      },
      colors: {
        exterior: {
          "7eez7nplog7a": {
            sku: "5036",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          ruym5z4zk7bp: {
            sku: "5035",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          dtjmzz3bsfrl: {
            sku: "5037",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          wibnckqtlqxe: {
            sku: "5039",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          "2h6rvjratd39": {
            sku: "5038",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          ys6fc5ecm0gr: {
            sku: "5041",
            project: "59",
            relevantVariants: ["elevation-4wd"],
          },
          u7k1meo46rf2: {
            sku: "5036",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          ab8wplqlfok3: {
            sku: "5035",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          bhv32vzt52gs: {
            sku: "5037",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          htk1s9thjb4s: {
            sku: "5039",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          "6p8m9s4ixtls": {
            sku: "5038",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          i6xtclih8key: {
            sku: "5041",
            project: "59",
            relevantVariants: ["elevation-2wd"],
          },
          oibbaumbmk6o: {
            sku: "5036",
            project: "59",
            relevantVariants: ["at4"],
          },
          y6wvhj01w1qp: {
            sku: "5035",
            project: "59",
            relevantVariants: ["at4"],
          },
          omegypbnovxt: {
            sku: "5037",
            project: "59",
            relevantVariants: ["at4"],
          },
          lvou9g0gwg5m: {
            sku: "5039",
            project: "59",
            relevantVariants: ["at4"],
          },
          w73rxovz5ab4: {
            sku: "5038",
            project: "59",
            relevantVariants: ["at4"],
          },
          yomo9egs18h1: {
            sku: "5041",
            project: "59",
            relevantVariants: ["at4"],
          },
          zxajfs4w3ai1: {
            sku: "5036",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          iwd9wmvjvi8i: {
            sku: "5035",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          mlkmxquzqkwn: {
            sku: "5037",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          "3q9yrk5nr6i1": {
            sku: "5039",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          p80xu92utnwf: {
            sku: "5038",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          sz19i9v0nu0s: {
            sku: "5041",
            project: "59",
            relevantVariants: ["at4-ultimate"],
          },
          "7du8wypy1esm": {
            sku: "5036",
            project: "59",
            relevantVariants: ["denali"],
          },
          y3ynqbe53hl4: {
            sku: "5035",
            project: "59",
            relevantVariants: ["denali"],
          },
          cw20iz1f9qih: {
            sku: "5039",
            project: "59",
            relevantVariants: ["denali"],
          },
          ynov100f4usu: {
            sku: "5040",
            project: "59",
            relevantVariants: ["denali"],
          },
          demq3ofi5wpc: {
            sku: "5038",
            project: "59",
            relevantVariants: ["denali"],
          },
          i8d4rlmjov72: {
            sku: "5041",
            project: "59",
            relevantVariants: ["denali"],
          },
          aozw0ed5yx7k: {
            sku: "5042",
            project: "59",
            relevantVariants: ["denali"],
          },
        },
        interior: {
          xyus3yrafri2: {
            sku: "5047",
            project: "59",
            relevantVariants: ["elevation-4wd"],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              q4efn17j0xpb: { add: false, snapToLastFrame: true },
            },
          },
          hp43ibg9l4ft: {
            sku: "5047",
            project: "59",
            relevantVariants: ["elevation-2wd"],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              aa191tcji6do: { add: false, snapToLastFrame: true },
            },
          },
          oz73ndw6lbhk: {
            sku: "5049",
            project: "59",
            relevantVariants: ["at4"],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              "3gjt48jevm9g": { add: false, snapToLastFrame: true },
            },
          },
          "81dr50kw77gu": {
            sku: "5048",
            project: "59",
            relevantVariants: ["at4-ultimate"],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              "9oajgf16euy4": { add: false, snapToLastFrame: true },
            },
          },
          zk7xg8dg1ekn: {
            sku: "5050",
            project: "59",
            relevantVariants: ["denali"],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ["mruisrltvi41", "qb16qdm7gr1x", "bl456utej9ez"],
            affectedInteractionOnApply: {
              xbdzchklx04d: { add: false, snapToLastFrame: true },
            },
          },
          bmbnnt678r0o: {
            sku: "5051",
            project: "59",
            relevantVariants: ["denali"],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ["mruisrltvi41", "qb16qdm7gr1x", "bl456utej9ez"],
            affectedInteractionOnApply: {
              xbdzchklx04d: { add: false, snapToLastFrame: true },
            },
          },
        },
      },
      features: {
        av8ukajwzjsm: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_20in_Wheels_Elevation",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wheels",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "56b99wbs39ki": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Orvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "ORVM",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            q4efn17j0xpb: { add: false, snapToLastFrame: true },
          },
        },
        slfnh3hjd6s8: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "Headlamp",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: "SHADER_Headlamps",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            q4efn17j0xpb: { add: false, snapToLastFrame: true },
          },
        },
        e31dagcaee09: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Roof Carrier",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Roof Carrier",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "3ofodapu2ddp": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "Front Compartment",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        muey3bbku37k: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Wireless_Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wireless Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        z7m52iyopf8c: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        awla0dgc0vgs: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Auto_Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        h0dy3khszwvy: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        vsefclj6vozz: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "7ncmf61zbg9j": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        jh03x1qu9di0: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        qesaxf0nj162: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-4wd"],
          messages: [
            {
              message: "SHADER_Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        et1jiatqexbt: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_20in_Wheels_Elevation",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wheels",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        kh1xk6tsachv: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Orvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "ORVM",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            aa191tcji6do: { add: false, snapToLastFrame: true },
          },
        },
        n9uci5v0q0no: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "Headlamp",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: "SHADER_Headlamps",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            aa191tcji6do: { add: false, snapToLastFrame: true },
          },
        },
        "6jn6rb1ajk00": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Roof Carrier",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Roof Carrier",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fzpdk9bjmbo4: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "Front Compartment",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "1m71ax5f4id6": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Wireless_Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wireless Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        thexucnyzlqx: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fz9wua33l4wm: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Auto_Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        a5fob6prph1z: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        pro1ugk226q0: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        sp46ano5o1g6: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        po1vxwjvhsua: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "10giu7b6ijpj": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["elevation-2wd"],
          messages: [
            {
              message: "SHADER_Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        eph3gxhsoo3x: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_20in_Wheels_Elevation",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wheels",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "1ttspnz1uru7": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "Headlamp",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: "SHADER_Headlamps",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        kkq9t0p36pre: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Front Grill_High",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front Grill",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "1ljgwnhfg5yu": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Power_Retractable",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Side Steps",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "7nnmna0acbhq": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        dvhzgcit9gq8: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Dual_Exhaust",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Dual Exhaust",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gj3zxztzghx9: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Red_Recovery_Hook",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Hooks",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "6c4xfhxqttcj": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "Suspension",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        y5rmij6r47yd: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "Second Row Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "9gc6nlc7mqbm": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "Front Compartment",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "9lug6s0cjccr": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Wireless_Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wireless Charger",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        g8laj4777we9: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        w2coh1cfcwcm: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Auto_Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k379fev4n1nf: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fmph3y1o9d79: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        dn9egqplaktn: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        v3g75ng0qbtv: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "4mpkdm2j8ori": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4"],
          messages: [
            {
              message: "SHADER_Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        sa7o4yw7u7mu: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_20in_Wheels_Elevation",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wheels",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "1slkxz7syxvp": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "Headlamp",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: "SHADER_Headlamps",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        zk4z2of152hu: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Front Grill_High",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front Grill",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ok95ya1c9f2c: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Power_Retractable",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Side Steps",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "3j9lbneqzehv": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        hbtmqob9llo2: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Dual_Exhaust",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Dual Exhaust",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "7rhtvb1tiuos": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Red_Recovery_Hook",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Hooks",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        x3gmjbedv48k: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "CAMERA_Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xkcj3q0s0hmx: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "Suspension",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        as606nc1f2st: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "Interior",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "9nml5px074gn": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "Front Compartment",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        bzo98svovyn4: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        b5wh08by8oys: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        nr6nsou5gim9: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ct2q24w7mow6: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "3h4c5jdf9m04": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        c9v1hui7o32s: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gu4r063wtclq: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "6l8f63wj44te": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Front_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k97e1b902d5w: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_HUD",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "HUD",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        l729qcq5vbuh: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Control_Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Center Control Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "9coc6cre7oka": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["at4-ultimate"],
          messages: [
            {
              message: "SHADER_Rear Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Rear Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ylam62d7djz9: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_20in_Wheels_Elevation",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Wheels",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        srix4ia0v5eq: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Power_Retractable",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Side Steps",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        yhpclqb0djib: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gu8nnyhcoq3y: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Front Grill",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front Grill",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "5djc26kkpfie": {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Side_Molding",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Chrome Body Molding",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        kbns5f4ez323: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "CAMERA_Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Roof",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        rhjetiqsprrh: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Bose_Speaker",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Bose Speaker",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: { add: false, snapToLastFrame: true },
          },
        },
        y6zcqp9r8fln: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "Front Compartment",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ddlwz0n6pzn8: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front and Rear AC",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "9cffzj69hili": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Irvm",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e6jhw2a3jpjj: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        hnbca1qrws9d: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Speedometer",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        b2e9rf4uwm3o: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Info Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        vox21clwc8i8: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Steering Shifter",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        jtptkqg4c1v0: {
          type: "graphic",
          view: "exterior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Lift gate",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fmo7hw3rxeyz: {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Front_Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Front Seats",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        "19t5w7j2faxq": {
          type: "graphic",
          view: "interior",
          relevantVariants: ["denali"],
          messages: [
            {
              message: "SHADER_Rear Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: "Rear Screen",
              identifiers: ["common_exterior"],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
      },
      accessories: {
        "3w06jsi5oinw": {
          view: "exterior",
          groupId: "elevation-4wd-g0",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Machined_Painted_Satin_Graphite",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        whv4p5vjna3p: {
          view: "exterior",
          groupId: "elevation-4wd-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Polished_Aluminum",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        o0effisb7huz: {
          view: "exterior",
          groupId: "elevation-4wd-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Machined_Painted_Carbon_Flash_Metallic",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        arv6xc8di0p2: {
          view: "exterior",
          groupId: "elevation-4wd-g0",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "22 inch Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        z60cgrm95zsc: {
          view: "exterior",
          groupId: "elevation-4wd-g1",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Roof_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte4: {
          view: "exterior",
          groupId: "elevation-4wd-g1",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Sunroof_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ROOF",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        xw46c5hhztat: {
          view: "exterior",
          groupId: "elevation-4wd-g2",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_WO_HUD_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "7ua1p3j98kiy": {
          view: "interior",
          groupId: "elevation-4wd-g2",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_W_HUD_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_HUD",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        t09zdke9k241: {
          view: "exterior",
          groupId: "elevation-4wd-g3",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate_Default",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        x8m9byz4k9y4: {
          view: "exterior",
          groupId: "elevation-4wd-g3",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            cid63atonu3q: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        f85e14irfgjr: {
          view: "exterior",
          groupId: "elevation-4wd-g4",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Emblems Black Illuminated Front Grille_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ax1vrv62y67b: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            q4efn17j0xpb: { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "38e3im5n9udc": {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Floor Mat-Front",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_MAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_MAT_LEFT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "79bhii9ntvo9": {
          view: "exterior",
          groupId: "elevation-4wd-g4",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black GMC Grille Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black GMC Grille Emblems",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "0cbl602swwhi": {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Nameplates Yukon",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Nameplates_Yukon",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Nameplates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            q4efn17j0xpb: { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        s9zcho1l9gqv: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Illuminated Sill Plates_YUKON",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            q4efn17j0xpb: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        fsedl2eprmy0: {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Screen_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_SCREEN",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        qqqb72272l8x: {
          view: "exterior",
          groupId: "elevation-4wd-g5",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "WO_Technology_Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "68es97qgriyh": {
          view: "exterior",
          groupId: "elevation-4wd-g5",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "W_Technology_Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        nuigmle8uxkr: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Max Trailering Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ol945v3g96o3: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Elevation_Variant_Parts",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "6mdkhlqtw9qo": {
          view: "exterior",
          groupId: "elevation-4wd-g6",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_WO_Heated Seats",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        bdhjvv0tik8h: {
          view: "exterior",
          groupId: "elevation-4wd-g6",
          display: false,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte5: {
          view: "exterior",
          groupId: "elevation-4wd-g7",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Grill_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte6: {
          view: "exterior",
          groupId: "elevation-4wd-g7",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_1_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte7: {
          view: "exterior",
          groupId: "elevation-4wd-g7",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_2_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-4wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        o6izcb1ru5o0: {
          view: "exterior",
          groupId: "elevation-2wd-g0",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Machined_Painted_Satin_Graphite",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "7dx04b353hiy": {
          view: "exterior",
          groupId: "elevation-2wd-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Polished_Aluminum",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        iki6mhzk69f8: {
          view: "exterior",
          groupId: "elevation-2wd-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Machined_Painted_Carbon_Flash_Metallic",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        s507n4vlfqa8: {
          view: "exterior",
          groupId: "elevation-2wd-g0",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "22 inch Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "4f9y7baneis7": {
          view: "exterior",
          groupId: "elevation-2wd-g1",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Roof_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "3sfzzmyqryib": {
          view: "exterior",
          groupId: "elevation-2wd-g1",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Sunroof_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ROOF",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "26hhkehlyy0f": {
          view: "exterior",
          groupId: "elevation-2wd-g2",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_WO_HUD_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        i44vvp9s1vpl: {
          view: "interior",
          groupId: "elevation-2wd-g2",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_W_HUD_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_HUD",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "81u5znzgazct": {
          view: "exterior",
          groupId: "elevation-2wd-g3",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate_Default",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "71dw4a7mytec": {
          view: "exterior",
          groupId: "elevation-2wd-g3",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            xdvvqsba76gn: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        w75uxl15tnqs: {
          view: "exterior",
          groupId: "elevation-2wd-g4",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Emblems Black Illuminated Front Grille_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        p0l17y9nyau4: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            aa191tcji6do: { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "8fmud7bac7m6": {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Floor Mat-Front",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_MAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_MAT_LEFT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "6tz8c3ggabkt": {
          view: "exterior",
          groupId: "elevation-2wd-g4",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black GMC Grille Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black GMC Grille Emblems",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        x96rsh8arus4: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Nameplates Yukon",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Nameplates_Yukon",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Nameplates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            aa191tcji6do: { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        dwto2y3t0e5a: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Illuminated Sill Plates_YUKON",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            aa191tcji6do: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "0evjcvrb9ug7": {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Screen_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_SCREEN",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        d3hm2vqzttar: {
          view: "exterior",
          groupId: "elevation-2wd-g5",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "WO_Technology_Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        jackzeoq4kxc: {
          view: "exterior",
          groupId: "elevation-2wd-g5",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "W_Technology_Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        vdumj7fgdp8a: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Max Trailering Package_Elevation",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        xomnqrfmrq7b: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Elevation_Variant_Parts",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ol945v3g96o323: {
          view: "exterior",
          groupId: "elevation-2wd-g6",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_WO_Heated Seats",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ol945v3g96o3435: {
          view: "exterior",
          groupId: "elevation-2wd-g6",
          display: false,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte8: {
          view: "exterior",
          groupId: "elevation-2wd-g7",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Grill_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte9: {
          view: "exterior",
          groupId: "elevation-2wd-g7",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_1_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        k4u455dsgte10: {
          view: "exterior",
          groupId: "elevation-2wd-g7",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_2_Elevation",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Grill",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["elevation-2wd"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "21nuzdavocyl": {
          view: "exterior",
          groupId: "at4-g0",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Machined_Painted_Carbon_Flash_Metallic",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        kx1uza6dq5ot: {
          view: "exterior",
          groupId: "at4-g0",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "22 inch Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "4efdsd97ofsv": {
          view: "exterior",
          groupId: "at4-g1",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate_Default",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        hmx6xdr280yk: {
          view: "exterior",
          groupId: "at4-g1",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            v3p6hnkfk4sx: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        lzb3mhbvi684: {
          view: "exterior",
          groupId: "at4-g2",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Emblems Black Illuminated Front Grille_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "7uw2r7k9jvjc": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            "3gjt48jevm9g": { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ibzcobiml3cq: {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Floor Mat-Front",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_MAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_MAT_LEFT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        rv7bg4mdrw95: {
          view: "exterior",
          groupId: "at4-g2",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Black GMC Grille Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black GMC Grille Emblems",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "49blm589zyjf": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Nameplates AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Nameplates_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            "3gjt48jevm9g": { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        b32ce7powkrp: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Illuminated Sill Plates_YUKON",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            "3gjt48jevm9g": {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "71l0ft0t7zv8": {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "529r8tz9f40j": {
          view: "interior",
          groupId: "at4-g3",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Mid_Bench_Seat_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        rdzllyd6co8k: {
          view: "interior",
          groupId: "at4-g3",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Mid_Captain_Seat_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_SEAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        cve371it9s7h: {
          view: "exterior",
          groupId: "at4-g4",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Roof_AT4",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "3u6vprohtrk6": {
          view: "exterior",
          groupId: "at4-g4",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Sunroof_AT4",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ROOF",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        w61wki046nr7: {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Screen_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_SCREEN",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ifgq6v1uhb9h: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "WO_Technology_Package_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "7vmqxynu27wn": {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "W_Technology_Package_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        aii5h9cgyg14: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "WO_Advanced_Security_Pack_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        z50pkzqtlb0j: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "W_Advanced_Security_Pack_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        d1se9jwnr8q9: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "AT4_Variant_Parts",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "788dseof5kp6": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        aii5h9cgyg19: {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Heated_Steering_Optional_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Steering",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        yfq9p87hxkkm: {
          view: "exterior",
          groupId: "at4-ultimate-g0",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Machined_Painted_Talos_Bronze_Metallic",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        yb3bv13k1d9s: {
          view: "exterior",
          groupId: "at4-ultimate-g0",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "22 inch Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "2b3vjc62r4n2": {
          view: "exterior",
          groupId: "at4-ultimate-g1",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate_Default",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        uqkubhykimks: {
          view: "exterior",
          groupId: "at4-ultimate-g1",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            lltey55ix5y7: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "0uw9h0rfwubw": {
          view: "exterior",
          groupId: "at4-ultimate-g2",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Emblems Black Illuminated Front Grille_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        sphrkplutvpy: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            "9oajgf16euy4": { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "2az8gut5k3kr": {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Floor Mat-Front",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_MAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_MAT_LEFT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        kvvnaw7j04w5: {
          view: "exterior",
          groupId: "at4-ultimate-g2",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black GMC Grille Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black GMC Grille Emblems",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Grill_Emblems_2",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        mfqdrqt5u93i: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Nameplates AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Nameplates_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            "9oajgf16euy4": { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "20717it6ugub": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Illuminated Sill Plates_YUKON",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            "9oajgf16euy4": {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ygqi3eegxe6y: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        hcujfdn25hed: {
          view: "exterior",
          groupId: "at4-ultimate-g3",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Night_Vision_AT4_ULT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        t838x538uzvt: {
          view: "exterior",
          groupId: "at4-ultimate-g3",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Night_Vision_AT4_ULT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_NIGHT_VISION",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        etqrtj2dywbf: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "AT4_ULT_Variant_Parts",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        d1se9jwnr8q934: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        aii5h9cgyg20: {
          view: "interior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Heated_Steering_Optional_AT4",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "Camera_Steering",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["at4-ultimate"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        drhsknaig5v4: {
          view: "exterior",
          groupId: "denali-g0",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Multi_Dimensional_Polished_Aluminum",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        ll389hjomzmw: {
          view: "exterior",
          groupId: "denali-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "UltraBright_Machined_Pained_Midnight",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "6r8odbd02l8r": {
          view: "exterior",
          groupId: "denali-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Polished_Aluminum",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        fht84o5uu46k: {
          view: "exterior",
          groupId: "denali-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Selective_Machined_Painted_Pearl_Nickel",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "1t3oatg17og0": {
          view: "exterior",
          groupId: "denali-g0",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Carbon_Flash_Metallic_Aluminum",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_ALLOY",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        wdbc64xihtb2: {
          view: "exterior",
          groupId: "denali-g0",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "22 inch Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Wheels",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "0tf9b3v2ow0e": {
          view: "exterior",
          groupId: "denali-g1",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate_Default",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "0k89247b1ar5": {
          view: "exterior",
          groupId: "denali-g1",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Cargo Area Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Cargo Sill Plate",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            yz2djr3m8zor: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        mruisrltvi41: {
          view: "interior",
          groupId: "denali-g2",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Default_Mid_Bench_Seat_Denali",
              identifiers: ["common_exterior"],
              condition: "(5050) is (interior-color)",
              isDefault: true,
              isStop: false,
            },
            {
              message: "Default_Mid_Bench_Seat_Teak_Light_Shale",
              identifiers: ["common_exterior"],
              condition: "(5051) is (interior-color)",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        qb16qdm7gr1x: {
          view: "interior",
          groupId: "denali-g2",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Optional_Mid_Captain_Seat_Denali",
              identifiers: ["common_exterior"],
              condition: "(5050) is (interior-color)",
              isDefault: true,
              isStop: false,
            },
            {
              message: "Optional_Mid_Captain_Seat_Teak_Light_Shale",
              identifiers: ["common_exterior"],
              condition: "(5051) is (interior-color)",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "CAMERA_SEAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "6kqqviaek2io": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Emblems Black Illuminated Front Grille",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Emblems Black",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "9emt18hb2kh7": {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_LED Puddle Lights",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: { add: false, snapToLastFrame: true },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        wc691tqh2727: {
          view: "interior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Floor Mat-Front",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_MAT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_MAT_LEFT",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        mdtdtacp2vnx: {
          view: "exterior",
          groupId: "",
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: "Illuminated Sill Plates_DENALI",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Illuminated Sill Plates",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: true,
              snapToLastFrame: true,
            },
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        "27l8cstufhje": {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: "Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: "ACC_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: "SHADER_Black Exhaust Tip",
              identifiers: ["common_exterior"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        fmniir2z3toa: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Denali_Variant_Parts",
              identifiers: ["exterior-color"],
              condition: "",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        bl456utej9ez: {
          view: "exterior",
          groupId: "",
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: "Denali Variants Parts Int Jet Black",
              identifiers: ["common_exterior"],
              condition: "(5050) is (interior-color)",
              isDefault: true,
              isStop: false,
            },
            {
              message: "Denali Variants Parts Int Light Shale",
              identifiers: ["common_exterior"],
              condition: "(5051) is (interior-color)",
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ["denali"],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
      },
      packages: {
        lrh1h0r2qg1c: {
          groupId: "elevation-4wd-pkg0",
          accessoryIds: ["nuigmle8uxkr"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-4wd"],
        },
        "0ybibmywl8w8": {
          groupId: "elevation-4wd-pkg1",
          accessoryIds: ["nuigmle8uxkr", "7ua1p3j98kiy"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-4wd"],
        },
        "1bxd2a82m8zj": {
          groupId: "elevation-4wd-pkg2",
          accessoryIds: ["arv6xc8di0p2", "79bhii9ntvo9", "0cbl602swwhi"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-4wd"],
        },
        a1lyjpkbd835: {
          groupId: "elevation-2wd-pkg0",
          accessoryIds: ["vdumj7fgdp8a"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-2wd"],
        },
        djmo7f5glzeo: {
          groupId: "elevation-2wd-pkg1",
          accessoryIds: ["vdumj7fgdp8a", "i44vvp9s1vpl"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-2wd"],
        },
        djmo7f5glzeo243: {
          groupId: "elevation-2wd-pkg2",
          accessoryIds: ["s507n4vlfqa8", "6tz8c3ggabkt", "x96rsh8arus4"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["elevation-2wd"],
        },
        x7vtyrufcgr0: {
          groupId: "at4-pkg0",
          accessoryIds: ["z50pkzqtlb0j"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["at4"],
        },
        sd9rqxud0aff: {
          groupId: "at4-pkg1",
          accessoryIds: ["7vmqxynu27wn"],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
          relevantVariants: ["at4"],
        },
      },
      interactions: {
        q4efn17j0xpb: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "DOORS_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "DOORS_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        cid63atonu3q: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILGATE_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "TAILGATE_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        "8y1ygewkzqwp": {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "SUNROOF_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "SUNROOF_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["elevation-4wd"],
          availableFor: {
            accessories: ["k4u455dsgte4"],
          },
        },
        xgeya76hww4y: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        z4fmgvbj6vl6: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        j9phsdy1vqre: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        agvzuwuqtkbm: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
        },
        ddqoq36ys5nl: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "SEAT_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "SEAT_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-4wd"],
          dependsOn: ["cid63atonu3q"],
        },
        aa191tcji6do: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "DOORS_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "DOORS_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        xdvvqsba76gn: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILGATE_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "TAILGATE_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        ixx09qpwupoa: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "SUNROOF_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "SUNROOF_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["elevation-2wd"],
          availableFor: {
            accessories: ["3sfzzmyqryib"],
          },
        },
        leogf3jjdxoa: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        r9lchu55ok3e: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        w7xsrj20ro3z: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        qldvhe66tc3c: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
        },
        grshgv2iww8c: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "SEAT_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "SEAT_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["elevation-2wd"],
          dependsOn: ["xdvvqsba76gn"],
        },
        "3gjt48jevm9g": {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "DOORS_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "DOORS_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["at4"],
        },
        v3p6hnkfk4sx: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILGATE_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "TAILGATE_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
        },
        flbo1iqfna62: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "SUNROOF_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "SUNROOF_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["at4"],
          availableFor: {
            accessories: ["3u6vprohtrk6"],
          },
        },
        pptw14tjetcr: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
        },
        vmbjveuli0by: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
        },
        "29fpskrobqlq": {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
        },
        c2s35fgsuiuu: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
        },
        o1jxfnah7tvf: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "SEAT_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "SEAT_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4"],
          dependsOn: ["v3p6hnkfk4sx"],
        },
        "9oajgf16euy4": {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "DOORS_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "DOORS_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        lltey55ix5y7: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILGATE_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "TAILGATE_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        b7kz4mrf26g2: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "SUNROOF_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "SUNROOF_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        yfb8ezuliqph: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        p4pudpriur0z: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        tdcwq6semoqw: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        kxr3vvny876a: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
        },
        "08h3pf8il71l": {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "SEAT_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "SEAT_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["at4-ultimate"],
          dependsOn: ["lltey55ix5y7"],
        },
        xbdzchklx04d: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "DOORS_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "DOORS_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 5.0385,
                beta: 1.448,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["denali"],
        },
        yz2djr3m8zor: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILGATE_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "TAILGATE_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
        },
        fwou2afhghpp: {
          type: "basic",
          view: ["exterior", "interior"],
          startMessages: [
            {
              message: "SUNROOF_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: "SUNROOF_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: "interior",
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: "interior",
              messages: {
                alpha: 4.7036,
                beta: 1.5732,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
          },
          relevantVariants: ["denali"],
        },
        "5g2eoomyui58": {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "HEADLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
        },
        "6146uzbd6kui": {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "DRL_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
        },
        iq7p37hq4g0j: {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "TAILLIGHT_GLOW",
              identifiers: ["common_exterior"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
        },
        "66sikckzjmb5": {
          type: "basic-light",
          view: ["exterior"],
          startMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "FOG_GLOW",
              identifiers: ["exterior-color"],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
        },
        vb0nbeis8kuj: {
          type: "basic",
          view: ["exterior"],
          startMessages: [
            {
              message: "SEAT_OPEN",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: "SEAT_CLOSE",
              identifiers: [
                "exterior-color",
                "common_exterior",
                "common_interior",
                "interior-color",
                "variants_parts",
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: "exterior",
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: "interior",
              messages: {},
            },
            interiorCamera_1: {
              type: "interior",
              messages: {},
            },
            interiorCamera_2: {
              type: "interior",
              messages: {},
            },
          },
          relevantVariants: ["denali"],
          dependsOn: ["yz2djr3m8zor"],
        },
      },
      hotspots: {
        exteriorCamera: {
          type: "exterior",
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerRadiusLimit: 3.2,
            upperRadiusLimit: 6.7,
            target: {
              x: 0,
              y: 0.65,
              z: 0,
            },
            isFovZoomModeOn: false,
          },
        },
        interiorCamera: {
          type: "interior",
          messages: {
            message: "INT_DEFAULT_CAMERA",
            identifiers: ["common_exterior"],
          },
        },
        interiorCamera_1: {
          type: "interior",
          messages: {
            message: "INT_DEFAULT_CAMERA_2",
            identifiers: ["common_exterior"],
          },
        },
        interiorCamera_2: {
          type: "interior",
          messages: {
            message: "INT_DEFAULT_CAMERA_3",
            identifiers: ["common_exterior"],
          },
        },
      },
      usdzPathWithVariable: "",
    },
  },
};
